// extracted by mini-css-extract-plugin
export default {"product":"ProductInfo_product__fuC4P","inputs":"ProductInfo_inputs__Aj6q9","upload":"ProductInfo_upload__JBBOe"};